import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveAIReviewSettings, createAIReviewSetting, deleteAIReviewSetting } from "../../api/bReviewsApi";

/**
 * Hook to update an existing AI review setting
 */
export function useSaveAISettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => saveAIReviewSettings(data),
    onSuccess: (response, variables) => {
      // Invalidate AI settings query to refetch with updated data
      queryClient.invalidateQueries({
        queryKey: ["ai-review-settings", variables.organisation_id],
      });
      // Also invalidate the detail query
      queryClient.invalidateQueries({
        queryKey: ["ai-review-setting-detail", variables.setting_id, variables.organisation_id],
      });
    },
  });
}

/**
 * Hook to create a new AI review setting
 */
export function useCreateAISetting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createAIReviewSetting(data),
    onSuccess: (response, variables) => {
      // Invalidate AI settings list query to refetch
      queryClient.invalidateQueries({
        queryKey: ["ai-review-settings", variables.organisation_id],
      });
    },
  });
}

/**
 * Hook to delete an AI review setting
 */
export function useDeleteAISetting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ settingId, organisationId }) => deleteAIReviewSetting(settingId, organisationId),
    onSuccess: (response, variables) => {
      // Invalidate AI settings list query to refetch
      queryClient.invalidateQueries({
        queryKey: ["ai-review-settings", variables.organisationId],
      });
    },
  });
}
